// extracted by mini-css-extract-plugin
export var badge = "sidebar-module--badge--605c6";
export var badgeGray = "sidebar-module--badgeGray--d41f7";
export var boxContent = "sidebar-module--boxContent--7a432";
export var boxName = "sidebar-module--boxName--71b25";
export var contactBlock = "sidebar-module--contactBlock--38848";
export var contactBlockItem = "sidebar-module--contactBlockItem--2b5ec";
export var content = "sidebar-module--content--4dd01";
export var iconButton = "sidebar-module--iconButton--3da39";
export var iconButtonCol = "sidebar-module--iconButtonCol--dd284";
export var infoListItem = "sidebar-module--infoListItem--dd860";
export var name = "sidebar-module--name--d393f";
export var profileAvatar = "sidebar-module--profileAvatar--15ff9";
export var resumeDownload = "sidebar-module--resumeDownload--79b1b";
export var rsBadgeBlue = "sidebar-module--rs-badge-blue--7b754";
export var rsBadgeContent = "sidebar-module--rs-badge-content--3db9e";
export var rsBadgeCyan = "sidebar-module--rs-badge-cyan--63aa6";
export var rsBadgeGreen = "sidebar-module--rs-badge-green--845e8";
export var rsBadgeIndependent = "sidebar-module--rs-badge-independent--ec696";
export var rsBadgeOrange = "sidebar-module--rs-badge-orange--b637e";
export var rsBadgeRed = "sidebar-module--rs-badge-red--cc37b";
export var rsBadgeViolet = "sidebar-module--rs-badge-violet--8904f";
export var rsBadgeYellow = "sidebar-module--rs-badge-yellow--21c4a";
export var rsBtnBlue = "sidebar-module--rs-btn-blue--09a1f";
export var rsBtnCyan = "sidebar-module--rs-btn-cyan--bfba4";
export var rsBtnGreen = "sidebar-module--rs-btn-green--6eefd";
export var rsBtnOrange = "sidebar-module--rs-btn-orange--4f7d1";
export var rsBtnRed = "sidebar-module--rs-btn-red--e2882";
export var rsBtnViolet = "sidebar-module--rs-btn-violet--86475";
export var rsBtnYellow = "sidebar-module--rs-btn-yellow--052c9";
export var rsFlexBoxGridItem1 = "sidebar-module--rs-flex-box-grid-item-1--b8aee";
export var rsFlexBoxGridItem10 = "sidebar-module--rs-flex-box-grid-item-10--c6a57";
export var rsFlexBoxGridItem11 = "sidebar-module--rs-flex-box-grid-item-11--3871b";
export var rsFlexBoxGridItem12 = "sidebar-module--rs-flex-box-grid-item-12--8de83";
export var rsFlexBoxGridItem13 = "sidebar-module--rs-flex-box-grid-item-13--3dcb2";
export var rsFlexBoxGridItem14 = "sidebar-module--rs-flex-box-grid-item-14--62dc7";
export var rsFlexBoxGridItem15 = "sidebar-module--rs-flex-box-grid-item-15--6a9d6";
export var rsFlexBoxGridItem16 = "sidebar-module--rs-flex-box-grid-item-16--6ea25";
export var rsFlexBoxGridItem17 = "sidebar-module--rs-flex-box-grid-item-17--dd6a6";
export var rsFlexBoxGridItem18 = "sidebar-module--rs-flex-box-grid-item-18--f366b";
export var rsFlexBoxGridItem19 = "sidebar-module--rs-flex-box-grid-item-19--6a599";
export var rsFlexBoxGridItem2 = "sidebar-module--rs-flex-box-grid-item-2--6f63a";
export var rsFlexBoxGridItem20 = "sidebar-module--rs-flex-box-grid-item-20--a7bab";
export var rsFlexBoxGridItem21 = "sidebar-module--rs-flex-box-grid-item-21--ca874";
export var rsFlexBoxGridItem22 = "sidebar-module--rs-flex-box-grid-item-22--d824c";
export var rsFlexBoxGridItem23 = "sidebar-module--rs-flex-box-grid-item-23--1b390";
export var rsFlexBoxGridItem24 = "sidebar-module--rs-flex-box-grid-item-24--a7221";
export var rsFlexBoxGridItem3 = "sidebar-module--rs-flex-box-grid-item-3--d117a";
export var rsFlexBoxGridItem4 = "sidebar-module--rs-flex-box-grid-item-4--6d789";
export var rsFlexBoxGridItem5 = "sidebar-module--rs-flex-box-grid-item-5--5fed3";
export var rsFlexBoxGridItem6 = "sidebar-module--rs-flex-box-grid-item-6--85c5f";
export var rsFlexBoxGridItem7 = "sidebar-module--rs-flex-box-grid-item-7--d1fbc";
export var rsFlexBoxGridItem8 = "sidebar-module--rs-flex-box-grid-item-8--c0b52";
export var rsFlexBoxGridItem9 = "sidebar-module--rs-flex-box-grid-item-9--0bfc3";
export var rsFlexBoxGridItemOrder1 = "sidebar-module--rs-flex-box-grid-item-order-1--07808";
export var rsFlexBoxGridItemOrder10 = "sidebar-module--rs-flex-box-grid-item-order-10--6213c";
export var rsFlexBoxGridItemOrder11 = "sidebar-module--rs-flex-box-grid-item-order-11--4bd1e";
export var rsFlexBoxGridItemOrder12 = "sidebar-module--rs-flex-box-grid-item-order-12--e2aea";
export var rsFlexBoxGridItemOrder13 = "sidebar-module--rs-flex-box-grid-item-order-13--81dcf";
export var rsFlexBoxGridItemOrder14 = "sidebar-module--rs-flex-box-grid-item-order-14--5385b";
export var rsFlexBoxGridItemOrder15 = "sidebar-module--rs-flex-box-grid-item-order-15--4ebdf";
export var rsFlexBoxGridItemOrder16 = "sidebar-module--rs-flex-box-grid-item-order-16--d4d81";
export var rsFlexBoxGridItemOrder17 = "sidebar-module--rs-flex-box-grid-item-order-17--0d62c";
export var rsFlexBoxGridItemOrder18 = "sidebar-module--rs-flex-box-grid-item-order-18--d0ad1";
export var rsFlexBoxGridItemOrder19 = "sidebar-module--rs-flex-box-grid-item-order-19--804d0";
export var rsFlexBoxGridItemOrder2 = "sidebar-module--rs-flex-box-grid-item-order-2--d4ad2";
export var rsFlexBoxGridItemOrder20 = "sidebar-module--rs-flex-box-grid-item-order-20--aec12";
export var rsFlexBoxGridItemOrder21 = "sidebar-module--rs-flex-box-grid-item-order-21--c0a2a";
export var rsFlexBoxGridItemOrder22 = "sidebar-module--rs-flex-box-grid-item-order-22--51a61";
export var rsFlexBoxGridItemOrder23 = "sidebar-module--rs-flex-box-grid-item-order-23--e716f";
export var rsFlexBoxGridItemOrder24 = "sidebar-module--rs-flex-box-grid-item-order-24--16d40";
export var rsFlexBoxGridItemOrder3 = "sidebar-module--rs-flex-box-grid-item-order-3--010ae";
export var rsFlexBoxGridItemOrder4 = "sidebar-module--rs-flex-box-grid-item-order-4--2552e";
export var rsFlexBoxGridItemOrder5 = "sidebar-module--rs-flex-box-grid-item-order-5--abde7";
export var rsFlexBoxGridItemOrder6 = "sidebar-module--rs-flex-box-grid-item-order-6--fde7e";
export var rsFlexBoxGridItemOrder7 = "sidebar-module--rs-flex-box-grid-item-order-7--4d396";
export var rsFlexBoxGridItemOrder8 = "sidebar-module--rs-flex-box-grid-item-order-8--f755b";
export var rsFlexBoxGridItemOrder9 = "sidebar-module--rs-flex-box-grid-item-order-9--47c7d";
export var rsTagBlue = "sidebar-module--rs-tag-blue--7779f";
export var rsTagCyan = "sidebar-module--rs-tag-cyan--46c44";
export var rsTagGreen = "sidebar-module--rs-tag-green--27c1c";
export var rsTagOrange = "sidebar-module--rs-tag-orange--e9423";
export var rsTagRed = "sidebar-module--rs-tag-red--3ebfe";
export var rsTagViolet = "sidebar-module--rs-tag-violet--b5663";
export var rsTagYellow = "sidebar-module--rs-tag-yellow--c68c3";
export var rsThemeDark = "sidebar-module--rs-theme-dark--96333";
export var rsThemeHighContrast = "sidebar-module--rs-theme-high-contrast--5d33b";
export var sideBar404Radius = "sidebar-module--sideBar404Radius--45ee1";
export var sidebarContent = "sidebar-module--sidebarContent--d5d3a";